import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatTooltipModule} from '@angular/material/tooltip';

import { CustomSpinnerDirective } from './custom-spinner.directive';
import { MatSelectInfiniteScrollDirective } from './mat-select-infinite-scroll.directive';
import { SecurityControlV3Directive } from './security-control-v3.directive';
import { StatusSessionsDirective } from './status-sessions-directive';
import { MatOnlyNumbersDirective } from './mat-only-number.directive';
import { BadgeStyleDirective } from './badge-style.directive';
import { MatOptionTooltipDirective } from './tooltip-length.directive';
import { SvgDragDropDirective } from './drag-and-drop.directive';
import { MaximizeCardContentDirective } from './maximize-card.directive';
import { MaximizeModalDirective } from './maximize-modal-card.directive';
import { UserProfileLinkDirective } from './user-profile-link.directive';


@NgModule({
  declarations: [CustomSpinnerDirective,BadgeStyleDirective,MatOptionTooltipDirective, SvgDragDropDirective,
                 MatSelectInfiniteScrollDirective,SecurityControlV3Directive, StatusSessionsDirective, MatOnlyNumbersDirective,
                  MaximizeCardContentDirective, MaximizeModalDirective, UserProfileLinkDirective],
  imports: [
    CommonModule, MatTooltipModule
  ],
  exports: [CustomSpinnerDirective, BadgeStyleDirective,MatOptionTooltipDirective, SvgDragDropDirective,
             MatSelectInfiniteScrollDirective, SecurityControlV3Directive, StatusSessionsDirective, MatOnlyNumbersDirective, MaximizeCardContentDirective, MaximizeModalDirective,UserProfileLinkDirective]
})
export class DirectivesModule { }
